import { render, staticRenderFns } from "./CampoArquivoNovo.vue?vue&type=template&id=32fd9713&scoped=true"
import script from "./CampoArquivoNovo.vue?vue&type=script&lang=js"
export * from "./CampoArquivoNovo.vue?vue&type=script&lang=js"
import style0 from "./CampoArquivoNovo.vue?vue&type=style&index=0&id=32fd9713&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fd9713",
  null
  
)

export default component.exports